import { useEffect, useEffectEvent } from "react"
import { useLocation } from "react-router"

import { useGetConnectAgentStatus } from "@/agent-state/connect-listeners"
import { useModal } from "@/components/core/Root/modal-root"
import NavigateWithContactModal from "@/components/modals/NavigateWithContactModal"
import { routesConfig } from "@/config/routes"
import { UndocumentedAgentStateType } from "@/helpers/atoms"

const useRedirectModalHook = (): void => {
  const { closeModal, showModal } = useModal()
  const agentStatus = useGetConnectAgentStatus()
  const location = useLocation()

  const isOffline = agentStatus === connect.AgentStateType.OFFLINE
  const isInit = agentStatus === connect.AgentStateType.INIT
  const isBusy =
    agentStatus === UndocumentedAgentStateType.SYSTEM ||
    agentStatus === UndocumentedAgentStateType.ERROR
  const isCallPanelRoute =
    location.pathname === routesConfig.AUTOMATIC_CALL_PANEL
  // this is for when agents at a manualCall(busy), they are not supposed to see the redirectModal
  // IIRC, without this condition, the modal would pop out when you start manual call, because the agentStatus would be SYSTEM (edited)
  const shouldShowNavigationModal = !isOffline && !isBusy && !isCallPanelRoute

  const showNavigationModal = useEffectEvent(async () => {
    await showModal<boolean>((close) => (
      <NavigateWithContactModal onClose={close} />
    ))
  })

  const onCleanup = useEffectEvent(() => {
    closeModal()
  })

  useEffect(() => {
    if (isInit) {
      return
    }

    if (shouldShowNavigationModal) {
      showNavigationModal()
    }

    return () => onCleanup()
  }, [shouldShowNavigationModal, isInit])
}

export { useRedirectModalHook }
